const theme = {
  sidebar: {
    width: '242px',
  },
}

export default theme
